import type {FC} from 'react';
import clsx from 'clsx';
import type {LayoutSchema} from 'schema/primitives/layout';

interface Props {
	children: React.ReactNode;
	layout?: LayoutSchema;
	className?: string;
	noXPadding?: boolean;
}

export const Container: FC<Props> = ({children, layout, className = '', noXPadding}) => {
	let spacingTop = 'pt-24 sm:pt-32';
	let spacingBottom = 'pb-24 sm:pb-32';

	switch (layout?.spacingBottom) {
		case 'none':
			spacingBottom = 'pb-0';
			break;
		case 'small':
			spacingBottom = 'pb-12 sm:pb-16';
			break;
		case 'normal':
			spacingBottom = 'pb-24 sm:pb-32';
			break;
		case 'large':
			spacingBottom = 'pb-32 sm:pb-40';
			break;
	}

	switch (layout?.spacingTop) {
		case 'none':
			spacingTop = 'pt-0';
			break;
		case 'small':
			spacingTop = 'pt-12 sm:pt-16';
			break;
		case 'normal':
			spacingTop = 'pt-24 sm:pt-32';
			break;
		case 'large':
			spacingTop = 'pt-32 sm:pt-40';
			break;
	}

	let paddingX = 'px-6 lg:px-8';

	if (noXPadding) {
		paddingX = 'sm:px-6 lg:px-8';
	}

	return (
		<div className={clsx(spacingBottom, spacingTop, className)}>
			<div className={clsx('mx-auto', 'max-w-7xl', paddingX)}>{children}</div>
		</div>
	);
};
